var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationIconNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 19C15 19.5304 14.7366 20.0391 14.2678 20.4142C13.7989 20.7893 13.163 21 12.5 21C11.837 21 11.2011 20.7893 10.7322 20.4142C10.2634 20.0391 10 19.5304 10 19L12.5 19H15Z",
    fill: "#95A5B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 17C5 16.4477 5.44772 16 6 16H19C19.5523 16 20 16.4477 20 17C20 17.5523 19.5523 18 19 18H6C5.44772 18 5 17.5523 5 17Z",
    fill: "#95A5B6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 9C16 8.24491 15.6636 7.49316 15.0177 6.91898C14.3679 6.34139 13.4638 6 12.5 6C11.5362 6 10.6322 6.34139 9.98242 6.91898C9.33647 7.49316 9.00004 8.24491 9.00004 9V14.5C9.00004 14.7271 8.92276 14.9474 8.78091 15.1247L6.78091 17.6247C6.4359 18.056 5.8066 18.1259 5.37534 17.7809C4.94408 17.4359 4.87416 16.8066 5.21917 16.3753L7.00004 14.1492L7.00004 9V8.99921C7.00027 7.63286 7.61202 6.3501 8.65369 5.42416C9.69173 4.50146 11.0769 4 12.5 4C13.9232 4 15.3083 4.50146 16.3464 5.42416C17.3883 6.35028 18 7.63336 18 9V14.1492L19.7809 16.3753C20.1259 16.8066 20.056 17.4359 19.6247 17.7809C19.1935 18.1259 18.5642 18.056 18.2192 17.6247L16.2192 15.1247C16.0773 14.9474 16 14.7271 16 14.5V9Z",
    fill: "#95A5B6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 3.5C14 3.30302 13.9612 3.10796 13.8858 2.92597C13.8104 2.74399 13.6999 2.57863 13.5607 2.43934C13.4214 2.30005 13.256 2.18956 13.074 2.11418C12.892 2.0388 12.697 2 12.5 2C12.303 2 12.108 2.0388 11.926 2.11418C11.744 2.18956 11.5786 2.30005 11.4393 2.43934C11.3001 2.57863 11.1896 2.74399 11.1142 2.92597C11.0388 3.10796 11 3.30302 11 3.5L11 5H14V3.5Z",
    fill: "#95A5B6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIconNew);
export default __webpack_public_path__ + "static/media/notification-icon-new.b735d543dca487f15330d15cfdd4bc82.svg";
export { ForwardRef as ReactComponent };